import React from "react";
import { ExternalLink } from "lucide-react";
import { PageHero, Section } from "../../components/Page";
import { SubNav, CONTACT_NAV } from "../../components/SubNav";
import { useApi } from "../../hooks/useApi";
import { useLang } from "../../i18n/LanguageContext";
import { PLATFORM_META } from "../../components/FollowStrip";

const handle = (url) => { try { const u = new URL(url); const p = u.pathname.replace(/\/+$/, "").split("/").pop(); return p && !p.startsWith("chat") ? `@${p.replace(/^@/, "")}` : u.hostname; } catch { return url; } };

export default function Connect() {
  const { data } = useApi("/settings/social");
  const { t } = useLang();
  const all = Object.keys(PLATFORM_META);
  const live = all.filter((k) => data?.[k]);
  const soon = all.filter((k) => data && !data[k]);
  return (
    <div data-testid="connect-page">
      <SubNav items={CONTACT_NAV} testId="contact-subnav" />
      <PageHero eyebrow={t("Stay connected")} title={t("Connect with us")}
        subtitle={t("Follow the Okuapemman Association of Massachusetts wherever you are — festival photos, meeting reminders, welfare news and the voices of our community.")}
        image="https://images.unsplash.com/photo-1634074967416-dd24d702c93c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />
      <Section>
        {data && live.length === 0 && <p className="text-muted-foreground" data-testid="connect-empty">{t("Our social pages are launching soon. Check back shortly!")}</p>}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {live.map((k) => { const m = PLATFORM_META[k]; return (
            <a key={k} href={data[k]} target="_blank" rel="noreferrer" className="card-hover glass group relative overflow-hidden rounded-2xl p-6" data-testid={`connect-card-${k}`}>
              <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full opacity-10 transition-transform group-hover:scale-125" style={{ background: m.color }} />
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-lg" style={{ background: m.color }}><m.Icon size={28} /></div>
              <h3 className="mt-4 font-serif-display text-2xl font-bold text-crimson">{m.name}</h3>
              <p className="font-mono-accent text-xs text-gold" data-testid={`connect-handle-${k}`}>{handle(data[k])}</p>
              <p className="mt-2 text-sm text-foreground/70">{t(m.blurb)}</p>
              <span className="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-semibold text-white transition-transform group-hover:scale-105" style={{ background: m.color }} data-testid={`connect-follow-${k}`}>{t(m.cta)} <ExternalLink size={14} /></span>
            </a>); })}
          {soon.map((k) => { const m = PLATFORM_META[k]; return (
            <div key={k} className="glass rounded-2xl p-6 opacity-60" data-testid={`connect-soon-${k}`}>
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-parchment-card text-muted-foreground"><m.Icon size={28} /></div>
              <h3 className="mt-4 font-serif-display text-2xl font-bold text-crimson/70">{m.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{t("Coming soon")}</p>
            </div>); })}
        </div>
      </Section>
    </div>
  );
}
